import React from 'react';

const items = [
  {
    icon: (
      <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
        <path d="M5 17H3a2 2 0 01-2-2V5a2 2 0 012-2h11a2 2 0 012 2v3m-4 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"/>
      </svg>
    ),
    label: 'We Come to You',
    sub: 'Home, office, or garage',
  },
  {
    icon: (
      <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
      </svg>
    ),
    label: 'Professional-Grade Products',
    sub: 'No shortcuts, ever',
  },
  {
    icon: (
      <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="10"/><path d="M12 8v4l3 3"/>
      </svg>
    ),
    label: 'Paint-Safe Process',
    sub: 'Zero cross-contamination',
  },
  {
    icon: (
      <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
      </svg>
    ),
    label: 'White-Glove Standard',
    sub: 'Every vehicle, every time',
  },
  {
    icon: (
      <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/>
      </svg>
    ),
    label: 'Orange County Service',
    sub: 'Newport Beach · Irvine · OC',
  },
];

export default function CredibilityStrip() {
  return (
    <section
      style={{
        background: 'var(--mamba-graphite)',
        borderTop: '1px solid rgba(107,33,168,0.2)',
        borderBottom: '1px solid rgba(107,33,168,0.2)',
        padding: '0',
      }}
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5">
          {items?.map((item, i) => (
            <div
              key={i}
              className="credibility-item"
              style={{
                padding: '24px 16px',
              }}
            >
              <div style={{ color: 'var(--mamba-gold-light)', marginBottom: '8px' }}>
                {item?.icon}
              </div>
              <div style={{ fontFamily: 'Manrope, sans-serif', fontWeight: 700, fontSize: '13px', color: 'var(--white)', textAlign: 'center', letterSpacing: '0.02em' }}>
                {item?.label}
              </div>
              <div style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '12px', color: 'var(--gray-dim)', textAlign: 'center' }}>
                {item?.sub}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
